import React from 'react';
import PropTypes from 'prop-types';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import {
    isEmpty,
    extractWorkSheetData,
    getWithExpiry
} from "../../../globals/GlobalFunctions";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import axios from 'axios';
import {refreshToken} from "../../../globals/GlobalFunctions";
import CircularProgress from "@mui/material/CircularProgress";
import Backdrop from "@mui/material/Backdrop";

export interface Props {
    excelData: any;
    currentDB: string;
}

type NullableBool = boolean | null;
type NullableNumber = number | null;

const parseNumber = (value: unknown): number | null => {
    const normalized = String(value ?? "").trim().replace(/,/g, "");
    if (normalized.length === 0) return null;

    const parsed = Number(normalized);
    return Number.isFinite(parsed) ? parsed : null;
};

function BulkPlanBuildImporter({ excelData, currentDB }: Props) {
    const [successAlert, setSuccessAlert] = React.useState(false);
    const [errorAlert, setErrorAlert] = React.useState(false);
    const [validationText, setValidationText] = React.useState("");
    const [validationError, setValidationError] = React.useState(false);
    const [loading, setLoading] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(false);
    const isRunningRef = React.useRef(false);
    const [planBuildImport, setPlanBuildImport] = React.useState({plan_ID: "",
        description: "", plan_Type: "", member_Ded_PPO: "", subscriber_Ded_PPO: "", ooP_Max_Net_Mem: "", ooP_Max_Net_Sub: "", member_Ded_OON: "", subscriber_Ded_OON: "", ooP_Max_OON_Mem: "", ooP_Max_OON_Sub: "",
        ded_In_To_Out: false, ded_Out_To_In: false, ooP_In_To_Out: false, ooP_Out_To_In: false, coIns_In_To_Out: false, coIns_Out_To_In: false, ooP_Calc_Option: "", lifetime_Max: "", lifetime_Max_Net: "",
        lifetime_Max_Oon: "", annual_Max: "", annual_Max_Net: "", annual_Max_Oon: "", vbasoftware_database: "CoastalAdminTest", vbapi_Token: ""});

    const [planTierImport, setPlanTierImport] = React.useState({plan_ID: "",
        description: "", plan_Type: "", accum_Name: "", member_Ded_PPO: 0 as NullableNumber, member_Ded_OON: 0 as NullableNumber, subscriber_Ded_PPO: 0 as NullableNumber, subscriber_Ded_OON: 0 as NullableNumber,
        ooP_Max_Net_Mem: 0 as NullableNumber, ooP_Max_OON_Mem: 0 as NullableNumber, ooP_Max_Net_Sub: 0 as NullableNumber, ooP_Max_OON_Sub: 0 as NullableNumber, vbasoftware_database: "CoastalAdminTest", vbapi_Token: ""});

    //meet with Logan to go over how we want this plan benefit import to look
    const [planBenefitImport, setPlanBenefitImport] = React.useState({description: "", benefitCode: "", covered: null as NullableBool, tierName: "", tierBenefit: "", coveredOne: null as NullableBool, tierNameTwo: "",
        tierBenefitTwo: "", coveredTwo: null as NullableBool, tierNameThree: "", tierBenefitThree: "", coveredThree: null as NullableBool, plan_ID: "", tierOne: null as NullableNumber, dedOne: null as NullableBool, copayOne: null as NullableNumber, tierTwo: null as NullableNumber,
        dedTwo: null as NullableBool, copayTwo: null as NullableNumber, tierThree: null as NullableNumber, dedThree: null as NullableBool, copayThree: null as NullableNumber, inNetwork: null as NullableNumber, dedFour: null as NullableBool, copayFour: null as NullableNumber, outOfNetwork: null as NullableNumber, copayFive: null as NullableNumber, vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: "",});

    let token = localStorage.getItem('jwt');

    const handleValidationClose = () => {
        setValidationError(false);
        setValidationText("");
    }

    const initialPlanBuildImport = {
        plan_ID: "",
        description: "",
        plan_Type: "",
        member_Ded_PPO: "", subscriber_Ded_PPO: "", ooP_Max_Net_Mem: "", ooP_Max_Net_Sub: "", member_Ded_OON: "", subscriber_Ded_OON: "", ooP_Max_OON_Mem: "", ooP_Max_OON_Sub: "",
        ded_In_To_Out: false, ded_Out_To_In: false, ooP_In_To_Out: false, ooP_Out_To_In: false, coIns_In_To_Out: false, coIns_Out_To_In: false, ooP_Calc_Option: "",
        lifetime_Max: "", lifetime_Max_Net: "",
        lifetime_Max_Oon: "", annual_Max: "", annual_Max_Net: "", annual_Max_Oon: "",
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: "",
    }

    const initialPlanTierImport = {
        plan_ID: "",
        description: "", plan_Type: "", accum_Name: "", member_Ded_PPO: 0, member_Ded_OON: 0, subscriber_Ded_PPO: 0, subscriber_Ded_OON: 0,
        ooP_Max_Net_Mem: 0, ooP_Max_OON_Mem: 0, ooP_Max_Net_Sub: 0, ooP_Max_OON_Sub: 0, vbasoftware_database: "CoastalAdminTest", vbapi_Token: ""
    }

    const initialPlanBenefitImport = {
        description: "",
        benefitCode: "",
        covered: null,
        tierName: "",
        tierBenefit: "",
        coveredOne: null,
        tierNameTwo: "",
        tierBenefitTwo: "",
        coveredTwo: null,
        tierNameThree: "",
        tierBenefitThree: "",
        coveredThree: null,
        plan_ID: "",
        tierOne: null,
        dedOne: null,
        copayOne: null,
        tierTwo: null,
        dedTwo: null,
        copayTwo: null,
        tierThree: null,
        dedThree: null,
        copayThree: null,
        inNetwork: null,
        dedFour: null,
        copayFour: null,
        outOfNetwork: null,
        copayFive: null,
        vbasoftware_database: "CoastalAdminTest",
        vbapi_Token: "",
    }

    const clearPlanBuildImport = () => {
        setPlanBuildImport({...initialPlanBuildImport});
    }

    const clearPlanTierImport = () => {
        setPlanTierImport({...initialPlanTierImport});
    }

    const clearPlanBenefitImport = () => {
        setPlanBenefitImport({...initialPlanBenefitImport});
    }

    const importPlanBuildImports = async (planBuildImportArray : any[], planTierImportArray : any[], planBenefitImportArray : any[]) => {
        refreshToken();
        setIsLoading(true);
        const response =
            await axios
                .put(
                    localStorage.getItem('baseURL') + 'PlanBuild/putList',
                    {
                        plans: planBuildImportArray,
                        tiers: planTierImportArray,
                        planBenefits: planBenefitImportArray,
                        vbasoftware_database: currentDB
                    },
                    {headers: {'Authorization': `Bearer ${token}`, accept: "*/*", "Content-Type": "application/json"}}
                ).then(() => {
                    setLoading(false);
                    setSuccessAlert(true);
                    setIsLoading(false);
                }).catch((error) => {
                    //console.log(response);
                    setLoading(false);
                    setValidationText(error.response.request.responseText);
                    setValidationError(true);
                    setIsLoading(false);
                });
        //console.log(response);
    }

    React.useEffect(() => {
        if (isEmpty(excelData) || !excelData?.Sheets) return;
        if (isRunningRef.current) return;

        isRunningRef.current = true;

        const runImport = async () => {
            try {
                //Check for data and that there is a sheet in the data named IDCodeValue
                const sheets = excelData?.Sheets;

                const planBuildImportArray: any[] = [];
                const planTierImportArray: any[] = [];
                const planBenefitImportArray: any[] = [];

                const planBuildSheet = sheets.PlanBuild;
                const tiersSheet = sheets.Tiers;
                const planBenefitSheet = sheets.PlanBenefit;

                if (!isEmpty(excelData) && planBuildSheet !== undefined) {
                    //console.log(excelData, "Made it to formatter!");

                    //global function to extract the data into a sequential array of cell data values as well as the column and row ranges
                    let sheetDataArray = extractWorkSheetData(excelData.Sheets.PlanBuild);

                    let rawCellArray: any[] = sheetDataArray[0];

                    let columnRange: number = sheetDataArray[1];

                    let rowRange: number = sheetDataArray[2];

                    //console.log(rawCellArray, "Raw Data");

                    //we need to find the column index of the values we require so we can grab the data for each row -- THIS IS WHERE COLUMN NAMES ARE SET
                    //we add 1 for each for the loop multiplier to account for it being zero based, but later we subtract 1 to account for the very fist row actually starting at zero
                    const planBuildIndexCollection = {
                        planIndex: rawCellArray.indexOf('Plan_ID') + 1,
                        descriptionIndex: rawCellArray.indexOf('Description') + 1,
                        planTypeIndex: rawCellArray.indexOf('Plan_Type') + 1,
                        memDedPPOIndex: rawCellArray.indexOf('IN IND DED') + 1,
                        subDedPPOIndex: rawCellArray.indexOf('IN FAM DED') + 1,
                        oopMaxNetMemIndex: rawCellArray.indexOf('IN IND OOP') + 1,
                        oopMaxNetSubIndex: rawCellArray.indexOf('IN FAM OOP') + 1,
                        memDedOONIndex: rawCellArray.indexOf('OON IND DED') + 1,
                        subDedOONIndex: rawCellArray.indexOf('OON FAM DED') + 1,
                        oopMaxOonMemIndex: rawCellArray.indexOf('OON IND OOP') + 1,
                        oopMaxOonSubIndex: rawCellArray.indexOf('OON FAM OOP') + 1,
                        dedInToOutIndex: rawCellArray.indexOf('Ded_In_To_Out') + 1,
                        dedOutToInIndex: rawCellArray.indexOf('Ded_Out_To_In') + 1,
                        oopInToOutIndex: rawCellArray.indexOf('OOP_In_To_Out') + 1,
                        oopOutToInIndex: rawCellArray.indexOf('OOP_Out_To_In') + 1,
                        coInsInToOutIndex: rawCellArray.indexOf('CoIns_In_To_Out') + 1,
                        coInsOutToInIndex: rawCellArray.indexOf('CoIns_Out_To_In') + 1,
                        oopCalcOptionIndex: rawCellArray.indexOf('OOP_Calc_Option') + 1,
                        lifetimeMaxIndex: rawCellArray.indexOf('Lifetime_Max') + 1,
                        lifetimeMaxNetIndex: rawCellArray.indexOf('Lifetime_Max_Net') + 1,
                        lifetimeMaxOonIndex: rawCellArray.indexOf('Lifetime_Max_OON') + 1,
                        annualMaxIndex: rawCellArray.indexOf('Annual_Max') + 1,
                        annualMaxNetIndex: rawCellArray.indexOf('Annual_Max_Net') + 1,
                        annualMaxOonIndex: rawCellArray.indexOf('Annual_Max_OON') + 1
                    }

                    if(planBuildIndexCollection.planIndex > 0 && planBuildIndexCollection.descriptionIndex > 0 && planBuildIndexCollection.planTypeIndex > 0
                        && planBuildIndexCollection.memDedPPOIndex > 0 && planBuildIndexCollection.subDedPPOIndex > 0 && planBuildIndexCollection.oopMaxNetMemIndex > 0
                        && planBuildIndexCollection.oopMaxNetSubIndex > 0 && planBuildIndexCollection.memDedOONIndex > 0 && planBuildIndexCollection.subDedOONIndex > 0
                        && planBuildIndexCollection.oopMaxOonMemIndex > 0 && planBuildIndexCollection.oopMaxOonSubIndex > 0
                        && planBuildIndexCollection.dedInToOutIndex > 0 && planBuildIndexCollection.dedOutToInIndex > 0 && planBuildIndexCollection.oopInToOutIndex > 0
                        && planBuildIndexCollection.oopOutToInIndex > 0 && planBuildIndexCollection.coInsInToOutIndex > 0 && planBuildIndexCollection.coInsOutToInIndex > 0
                        && planBuildIndexCollection.oopCalcOptionIndex > 0
                        && planBuildIndexCollection.lifetimeMaxIndex > 0 && planBuildIndexCollection.lifetimeMaxNetIndex > 0 && planBuildIndexCollection.lifetimeMaxOonIndex > 0
                        && planBuildIndexCollection.annualMaxIndex > 0 && planBuildIndexCollection.annualMaxNetIndex > 0 && planBuildIndexCollection.annualMaxOonIndex > 0) {

                        for (let i = 1; i < rowRange; i++) {
                            //for each new array we skip over the previous records determined by the column length, removing 1 to account for our zero based index at the beginning
                            let rowMultiplier = columnRange * i - 1;

                            if (planBuildIndexCollection.planIndex > 0) {
                                planBuildImport.plan_ID = rawCellArray[(rowMultiplier + planBuildIndexCollection.planIndex)].toString();
                            }

                            if (planBuildIndexCollection.descriptionIndex > 0) {
                                planBuildImport.description = rawCellArray[(rowMultiplier + planBuildIndexCollection.descriptionIndex)].toString();
                            }

                            if (planBuildIndexCollection.planTypeIndex > 0) {
                                planBuildImport.plan_Type = rawCellArray[(rowMultiplier + planBuildIndexCollection.planTypeIndex)].toString();
                            }

                            if (planBuildIndexCollection.memDedPPOIndex > 0) {
                                planBuildImport.member_Ded_PPO = rawCellArray[(rowMultiplier + planBuildIndexCollection.memDedPPOIndex)].toString();
                            }

                            if (planBuildIndexCollection.subDedPPOIndex > 0) {
                                planBuildImport.subscriber_Ded_PPO = rawCellArray[(rowMultiplier + planBuildIndexCollection.subDedPPOIndex)].toString();
                            }

                            if (planBuildIndexCollection.oopMaxNetMemIndex > 0) {
                                planBuildImport.ooP_Max_Net_Mem = rawCellArray[(rowMultiplier + planBuildIndexCollection.oopMaxNetMemIndex)].toString();
                            }

                            if (planBuildIndexCollection.oopMaxNetSubIndex > 0) {
                                planBuildImport.ooP_Max_Net_Sub = rawCellArray[(rowMultiplier + planBuildIndexCollection.oopMaxNetSubIndex)].toString();
                            }

                            if (planBuildIndexCollection.memDedOONIndex > 0) {
                                planBuildImport.member_Ded_OON = rawCellArray[(rowMultiplier + planBuildIndexCollection.memDedOONIndex)].toString();
                            }

                            if (planBuildIndexCollection.subDedOONIndex > 0) {
                                planBuildImport.subscriber_Ded_OON = rawCellArray[(rowMultiplier + planBuildIndexCollection.subDedOONIndex)].toString();
                            }

                            if (planBuildIndexCollection.oopMaxOonMemIndex > 0) {
                                planBuildImport.ooP_Max_OON_Mem = rawCellArray[(rowMultiplier + planBuildIndexCollection.oopMaxOonMemIndex)].toString();
                            }

                            if (planBuildIndexCollection.oopMaxOonSubIndex > 0) {
                                planBuildImport.ooP_Max_OON_Sub = rawCellArray[(rowMultiplier + planBuildIndexCollection.oopMaxOonSubIndex)].toString();
                            }

                            if (planBuildIndexCollection.dedInToOutIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBuildIndexCollection.dedInToOutIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBuildIndexCollection.dedInToOutIndex)].toString().toUpperCase() === "N" ) {
                                    planBuildImport.ded_In_To_Out = false;
                                }
                                else {
                                    planBuildImport.ded_In_To_Out = true;
                                }
                            }

                            if (planBuildIndexCollection.dedOutToInIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBuildIndexCollection.dedOutToInIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBuildIndexCollection.dedOutToInIndex)].toString().toUpperCase() === "N" ) {
                                    planBuildImport.ded_Out_To_In = false;
                                }
                                else {
                                    planBuildImport.ded_Out_To_In = true;
                                }
                            }

                            if (planBuildIndexCollection.oopInToOutIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBuildIndexCollection.oopInToOutIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBuildIndexCollection.oopInToOutIndex)].toString().toUpperCase() === "N" ) {
                                    planBuildImport.ooP_In_To_Out = false;
                                }
                                else {
                                    planBuildImport.ooP_In_To_Out = true;
                                }
                            }

                            if (planBuildIndexCollection.oopOutToInIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBuildIndexCollection.oopOutToInIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBuildIndexCollection.oopOutToInIndex)].toString().toUpperCase() === "N" ) {
                                    planBuildImport.ooP_Out_To_In = false;
                                }
                                else {
                                    planBuildImport.ooP_Out_To_In = true;
                                }
                            }

                            if (planBuildIndexCollection.coInsInToOutIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBuildIndexCollection.coInsInToOutIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBuildIndexCollection.coInsInToOutIndex)].toString().toUpperCase() === "N" ) {
                                    planBuildImport.coIns_In_To_Out = false;
                                }
                                else {
                                    planBuildImport.coIns_In_To_Out = true;
                                }
                            }

                            if (planBuildIndexCollection.coInsOutToInIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBuildIndexCollection.coInsOutToInIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBuildIndexCollection.coInsOutToInIndex)].toString().toUpperCase() === "N" ) {
                                    planBuildImport.coIns_Out_To_In = false;
                                }
                                else {
                                    planBuildImport.coIns_Out_To_In = true;
                                }
                            }

                            if (planBuildIndexCollection.oopCalcOptionIndex > 0) {
                                planBuildImport.ooP_Calc_Option = rawCellArray[(rowMultiplier + planBuildIndexCollection.oopCalcOptionIndex)].toString();
                            }

                            if (planBuildIndexCollection.lifetimeMaxIndex > 0) {
                                planBuildImport.lifetime_Max = rawCellArray[(rowMultiplier + planBuildIndexCollection.lifetimeMaxIndex)].toString();
                            }

                            if (planBuildIndexCollection.lifetimeMaxNetIndex > 0) {
                                planBuildImport.lifetime_Max_Net = rawCellArray[(rowMultiplier + planBuildIndexCollection.lifetimeMaxNetIndex)].toString();
                            }

                            if (planBuildIndexCollection.lifetimeMaxOonIndex > 0) {
                                planBuildImport.lifetime_Max_Oon = rawCellArray[(rowMultiplier + planBuildIndexCollection.lifetimeMaxOonIndex)].toString();
                            }

                            if (planBuildIndexCollection.annualMaxIndex > 0) {
                                planBuildImport.annual_Max = rawCellArray[(rowMultiplier + planBuildIndexCollection.annualMaxIndex)].toString();
                            }

                            if (planBuildIndexCollection.annualMaxNetIndex > 0) {
                                planBuildImport.annual_Max_Net = rawCellArray[(rowMultiplier + planBuildIndexCollection.annualMaxNetIndex)].toString();
                            }

                            if (planBuildIndexCollection.annualMaxOonIndex > 0) {
                                planBuildImport.annual_Max_Oon = rawCellArray[(rowMultiplier + planBuildIndexCollection.annualMaxOonIndex)].toString();
                            }

                            planBuildImport.vbasoftware_database = currentDB;

                            planBuildImport.vbapi_Token = getWithExpiry('vbapi_Token');

                            //TODO: Finish checking validation here
                            if(planBuildImport.plan_ID.length > 0 && planBuildImport.description.length > 0 && planBuildImport.plan_Type.length > 0 &&
                                planBuildImport.member_Ded_PPO.length > 0 && planBuildImport.subscriber_Ded_PPO.length > 0 && planBuildImport.ooP_Max_Net_Mem.length > 0 &&
                                planBuildImport.ooP_Max_Net_Sub.length > 0 && planBuildImport.member_Ded_OON.length > 0 && planBuildImport.subscriber_Ded_OON.length > 0 &&
                                planBuildImport.ooP_Max_OON_Mem.length > 0 && planBuildImport.ooP_Max_OON_Sub.length > 0 && planBuildImport.ded_In_To_Out !== null &&
                                planBuildImport.ded_Out_To_In !== null && planBuildImport.ooP_In_To_Out !== null && planBuildImport.ooP_Out_To_In !== null &&
                                planBuildImport.coIns_In_To_Out !== null && planBuildImport.coIns_Out_To_In !== null && planBuildImport.ooP_Calc_Option.length > 0 &&
                                planBuildImport.lifetime_Max.length > 0 && planBuildImport.lifetime_Max_Net.length > 0 && planBuildImport.lifetime_Max_Oon.length > 0 &&
                                planBuildImport.annual_Max.length > 0 && planBuildImport.annual_Max_Net.length > 0 && planBuildImport.annual_Max_Oon.length > 0) {
                                planBuildImportArray.push({...planBuildImport});
                            }

                            planBuildImport.plan_ID = initialPlanBuildImport.plan_ID;
                            planBuildImport.description = initialPlanBuildImport.description;
                            planBuildImport.plan_Type = initialPlanBuildImport.plan_Type;
                            planBuildImport.member_Ded_PPO = initialPlanBuildImport.member_Ded_PPO;
                            planBuildImport.subscriber_Ded_PPO = initialPlanBuildImport.subscriber_Ded_PPO;
                            planBuildImport.ooP_Max_Net_Mem = initialPlanBuildImport.ooP_Max_Net_Mem;
                            planBuildImport.ooP_Max_Net_Sub = initialPlanBuildImport.ooP_Max_Net_Sub;
                            planBuildImport.member_Ded_OON = initialPlanBuildImport.member_Ded_OON;
                            planBuildImport.subscriber_Ded_OON = initialPlanBuildImport.subscriber_Ded_OON;
                            planBuildImport.ooP_Max_OON_Mem = initialPlanBuildImport.ooP_Max_OON_Mem;
                            planBuildImport.ooP_Max_OON_Sub = initialPlanBuildImport.ooP_Max_OON_Sub;
                            planBuildImport.ded_In_To_Out = initialPlanBuildImport.ded_In_To_Out;
                            planBuildImport.ded_Out_To_In = initialPlanBuildImport.ded_Out_To_In;
                            planBuildImport.ooP_In_To_Out = initialPlanBuildImport.ooP_In_To_Out;
                            planBuildImport.ooP_Out_To_In = initialPlanBuildImport.ooP_Out_To_In;
                            planBuildImport.coIns_In_To_Out = initialPlanBuildImport.coIns_In_To_Out;
                            planBuildImport.coIns_Out_To_In = initialPlanBuildImport.coIns_Out_To_In;
                            planBuildImport.ooP_Calc_Option = initialPlanBuildImport.ooP_Calc_Option;
                            planBuildImport.lifetime_Max = initialPlanBuildImport.lifetime_Max;
                            planBuildImport.lifetime_Max_Net = initialPlanBuildImport.lifetime_Max_Net;
                            planBuildImport.lifetime_Max_Oon = initialPlanBuildImport.lifetime_Max_Oon;
                            planBuildImport.annual_Max = initialPlanBuildImport.annual_Max;
                            planBuildImport.annual_Max_Net = initialPlanBuildImport.annual_Max_Net;
                            planBuildImport.annual_Max_Oon = initialPlanBuildImport.annual_Max_Oon;


                            clearPlanBuildImport();
                        }

                        //This initias the Axios request, this will need to be modified with optional parameters
                        //importPlanBuildImports(planBuildImportArray);

                        //excelData.Sheets.PlanBuild = undefined;
                    }
                    else {
                        //setValidationText("Group ID, Plan ID, and Vendor are required.");
                        //setValidationError(true);
                    }
                }

                if (!isEmpty(excelData) && tiersSheet !== undefined)
                {
                    let tierSheetDataArray = extractWorkSheetData(excelData.Sheets.Tiers);

                    let rawCellArray: any[] = tierSheetDataArray[0];

                    let columnRange: number = tierSheetDataArray[1];

                    let rowRange: number = tierSheetDataArray[2];

                    const planTierIndexCollection = {
                        planIndex: rawCellArray.indexOf('Plan_ID') + 1,
                        descriptionIndex: rawCellArray.indexOf('Description') + 1,
                        planTypeIndex: rawCellArray.indexOf('Plan_Type') + 1,
                        tierNameIndex: rawCellArray.indexOf('Tier Name') + 1,
                        memDedPPOOONIndex: rawCellArray.indexOf('Tier x IND DED') + 1,
                        subDedPPOOONIndex: rawCellArray.indexOf('Tier x FAM DED') + 1,
                        oopMaxNetOONMemIndex: rawCellArray.indexOf('Tier x IND OOP') + 1,
                        oopMaxNetOONSubIndex: rawCellArray.indexOf('Tier x FAM OOP') + 1
                    }

                    if (planTierIndexCollection.planIndex > 0 && planTierIndexCollection.descriptionIndex > 0 && planTierIndexCollection.planTypeIndex > 0
                        && planTierIndexCollection.tierNameIndex > 0 && planTierIndexCollection.memDedPPOOONIndex > 0 && planTierIndexCollection.subDedPPOOONIndex > 0
                        && planTierIndexCollection.oopMaxNetOONMemIndex > 0 && planTierIndexCollection.oopMaxNetOONSubIndex > 0) {

                        for (let i = 1; i < rowRange; i++) {
                            let rowMultiplier = columnRange * i - 1;

                            if (planTierIndexCollection.planIndex > 0) {
                                planTierImport.plan_ID = rawCellArray[(rowMultiplier + planTierIndexCollection.planIndex)].toString();
                            }

                            if (planTierIndexCollection.descriptionIndex > 0) {
                                planTierImport.description = rawCellArray[(rowMultiplier + planTierIndexCollection.descriptionIndex)].toString();
                            }

                            if (planTierIndexCollection.planTypeIndex > 0) {
                                planTierImport.plan_Type = rawCellArray[(rowMultiplier + planTierIndexCollection.planTypeIndex)].toString();
                            }

                            if (planTierIndexCollection.tierNameIndex > 0) {
                                planTierImport.accum_Name = rawCellArray[(rowMultiplier + planTierIndexCollection.tierNameIndex)].toString();
                            }

                            if (planTierIndexCollection.memDedPPOOONIndex > 0) {
                                planTierImport.member_Ded_PPO = parseNumber(rawCellArray[(rowMultiplier + planTierIndexCollection.memDedPPOOONIndex)]);
                                planTierImport.member_Ded_OON = parseNumber(rawCellArray[(rowMultiplier + planTierIndexCollection.memDedPPOOONIndex)]);
                            }

                            if (planTierIndexCollection.subDedPPOOONIndex > 0) {
                                planTierImport.subscriber_Ded_PPO = parseNumber(rawCellArray[(rowMultiplier + planTierIndexCollection.subDedPPOOONIndex)]);
                                planTierImport.subscriber_Ded_OON = parseNumber(rawCellArray[(rowMultiplier + planTierIndexCollection.subDedPPOOONIndex)]);
                            }

                            if (planTierIndexCollection.oopMaxNetOONMemIndex > 0) {
                                planTierImport.ooP_Max_Net_Mem = parseNumber(rawCellArray[(rowMultiplier + planTierIndexCollection.oopMaxNetOONMemIndex)]);
                                planTierImport.ooP_Max_OON_Mem = parseNumber(rawCellArray[(rowMultiplier + planTierIndexCollection.oopMaxNetOONMemIndex)]);
                            }

                            if (planTierIndexCollection.oopMaxNetOONSubIndex > 0) {
                                planTierImport.ooP_Max_Net_Sub = parseNumber(rawCellArray[(rowMultiplier + planTierIndexCollection.oopMaxNetOONSubIndex)]);
                                planTierImport.ooP_Max_OON_Sub = parseNumber(rawCellArray[(rowMultiplier + planTierIndexCollection.oopMaxNetOONSubIndex)]);
                            }

                            planTierImport.vbasoftware_database = currentDB;

                            planTierImport.vbapi_Token = getWithExpiry('vbapi_Token');

                            //TODO: Finish checking validation here
                            if (planTierImport.plan_ID.length > 0 && planTierImport.description.length > 0 && planTierImport.plan_Type.length > 0 &&
                                planTierImport.accum_Name.length > 0 && planTierImport.member_Ded_PPO != null && planTierImport.member_Ded_OON != null &&
                                planTierImport.subscriber_Ded_PPO != null && planTierImport.subscriber_Ded_OON != null && planTierImport.ooP_Max_Net_Mem != null &&
                                planTierImport.ooP_Max_OON_Mem != null && planTierImport.ooP_Max_Net_Sub != null && planTierImport.ooP_Max_OON_Sub != null) {
                                planTierImportArray.push({...planTierImport});
                            }

                            planTierImport.plan_ID = initialPlanTierImport.plan_ID;
                            planTierImport.description = initialPlanTierImport.description;
                            planTierImport.plan_Type = initialPlanTierImport.plan_Type;
                            planTierImport.accum_Name = initialPlanTierImport.accum_Name;
                            planTierImport.member_Ded_OON = initialPlanTierImport.member_Ded_OON;
                            planTierImport.member_Ded_PPO = initialPlanTierImport.member_Ded_PPO;
                            planTierImport.subscriber_Ded_OON = initialPlanTierImport.subscriber_Ded_OON;
                            planTierImport.subscriber_Ded_PPO = initialPlanTierImport.subscriber_Ded_PPO;
                            planTierImport.ooP_Max_Net_Mem = initialPlanTierImport.ooP_Max_Net_Mem;
                            planTierImport.ooP_Max_OON_Mem = initialPlanTierImport.ooP_Max_OON_Mem;
                            planTierImport.ooP_Max_Net_Sub = initialPlanTierImport.ooP_Max_Net_Sub;
                            planTierImport.ooP_Max_OON_Sub = initialPlanTierImport.ooP_Max_OON_Sub;

                            clearPlanTierImport();
                        }

                        //excelData.Sheets.Tiers = undefined;
                    }
                    else {
                        //setValidationText("Group ID, Plan ID, and Vendor are required.");
                        //setValidationError(true);
                    }
                }

                if (!isEmpty(excelData) && planBenefitSheet !== undefined)
                {
                    let planBenefitSheetDataArray = extractWorkSheetData(excelData.Sheets.PlanBenefit);

                    let rawCellArray: any[] = planBenefitSheetDataArray[0];

                    let columnRange: number = planBenefitSheetDataArray[1];

                    let rowRange: number = planBenefitSheetDataArray[2];

                    const planBenefitIndexCollection = {
                        descriptionIndex: rawCellArray.indexOf('Benefit Code Description') + 1,
                        benefitCodeIndex: rawCellArray.indexOf('Benefit Code') + 1,
                        coveredIndex: rawCellArray.indexOf('Covered') + 1,
                        tierNameIndex: rawCellArray.indexOf('Tier Name (1)') + 1,
                        tierBenefitIndex: rawCellArray.indexOf('Tier (1) Benefits') + 1,
                        coveredOneIndex: rawCellArray.indexOf('Covered (1)') + 1,
                        tierNameTwoIndex: rawCellArray.indexOf('Tier Name (2)') + 1,
                        tierBenefitTwoIndex: rawCellArray.indexOf('Tier (2) Benefits') + 1,
                        coveredTwoIndex: rawCellArray.indexOf('Covered (2)') + 1,
                        tierNameThreeIndex: rawCellArray.indexOf('Tier Name (3)') + 1,
                        tierBenefitThreeIndex: rawCellArray.indexOf('Tier (3) Benefits') + 1,
                        coveredThreeIndex: rawCellArray.indexOf('Covered (3)') + 1,
                        planIDIndex: rawCellArray.indexOf('PLAN ID') + 1,
                        tierOneIndex: rawCellArray.indexOf('Tier (1)') + 1,
                        dedOneIndex: rawCellArray.indexOf('DED (1)') + 1,
                        copayOneIndex: rawCellArray.indexOf('COPAY (1)') + 1,
                        tierTwoIndex: rawCellArray.indexOf('Tier (2)') + 1,
                        dedTwoIndex: rawCellArray.indexOf('DED (2)') + 1,
                        copayTwoIndex: rawCellArray.indexOf('COPAY (2)') + 1,
                        tierThreeIndex: rawCellArray.indexOf('Tier (3)') + 1,
                        dedThreeIndex: rawCellArray.indexOf('DED (3)') + 1,
                        copayThreeIndex: rawCellArray.indexOf('COPAY (3)') + 1,
                        inNetworkIndex: rawCellArray.indexOf('In Network') + 1,
                        dedFourIndex: rawCellArray.indexOf('DED (4)') + 1,
                        copayFourIndex: rawCellArray.indexOf('COPAY (4)') + 1,
                        outOfNetworkIndex: rawCellArray.indexOf('Out-of-Network') + 1,
                        copayFiveIndex: rawCellArray.indexOf('COPAY (5)') + 1
                    }

                    if (planBenefitIndexCollection.descriptionIndex > 0 && planBenefitIndexCollection.benefitCodeIndex > 0 && planBenefitIndexCollection.coveredIndex > 0 && planBenefitIndexCollection.tierNameIndex > 0 &&
                        planBenefitIndexCollection.tierBenefitIndex > 0 && planBenefitIndexCollection.coveredOneIndex > 0 && planBenefitIndexCollection.tierNameTwoIndex > 0 && planBenefitIndexCollection.tierBenefitTwoIndex > 0 &&
                        planBenefitIndexCollection.coveredTwoIndex > 0 && planBenefitIndexCollection.tierNameThreeIndex > 0 && planBenefitIndexCollection.tierBenefitThreeIndex > 0 && planBenefitIndexCollection.coveredThreeIndex > 0 &&
                        planBenefitIndexCollection.planIDIndex > 0 && planBenefitIndexCollection.tierOneIndex > 0 && planBenefitIndexCollection.dedOneIndex > 0 && planBenefitIndexCollection.copayOneIndex > 0 &&
                        planBenefitIndexCollection.tierTwoIndex > 0 && planBenefitIndexCollection.dedTwoIndex > 0 && planBenefitIndexCollection.copayTwoIndex > 0 && planBenefitIndexCollection.tierThreeIndex > 0 &&
                        planBenefitIndexCollection.dedThreeIndex > 0 && planBenefitIndexCollection.copayThreeIndex > 0 && planBenefitIndexCollection.inNetworkIndex > 0 && planBenefitIndexCollection.dedFourIndex > 0 &&
                        planBenefitIndexCollection.copayFourIndex > 0 && planBenefitIndexCollection.outOfNetworkIndex > 0 && planBenefitIndexCollection.copayFiveIndex > 0) {

                        for (let i = 1; i < rowRange; i++) {
                            let rowMultiplier = columnRange * i - 1;

                            if (planBenefitIndexCollection.descriptionIndex > 0) {
                                planBenefitImport.description = rawCellArray[(rowMultiplier + planBenefitIndexCollection.descriptionIndex)].toString();
                            }

                            if (planBenefitIndexCollection.benefitCodeIndex > 0) {
                                planBenefitImport.benefitCode = rawCellArray[(rowMultiplier + planBenefitIndexCollection.benefitCodeIndex)].toString();
                            }

                            if (planBenefitIndexCollection.coveredIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredIndex)].toString().toUpperCase() === "N" ) {
                                    planBenefitImport.covered = false;
                                }
                                else if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredIndex)].toString().toUpperCase() === "YES" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredIndex)].toString().toUpperCase() === "Y" ) {
                                    planBenefitImport.covered = true;
                                }
                                else {
                                    planBenefitImport.covered = null;
                                }
                            }

                            if (planBenefitIndexCollection.tierNameIndex > 0) {
                                planBenefitImport.tierName = rawCellArray[(rowMultiplier + planBenefitIndexCollection.tierNameIndex)].toString();
                            }

                            if (planBenefitIndexCollection.tierBenefitIndex > 0) {
                                planBenefitImport.tierBenefit = rawCellArray[(rowMultiplier + planBenefitIndexCollection.tierBenefitIndex)].toString();
                            }

                            if (planBenefitIndexCollection.coveredOneIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredOneIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredOneIndex)].toString().toUpperCase() === "N" ) {
                                    planBenefitImport.coveredOne = false;
                                }
                                else if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredOneIndex)].toString().toUpperCase() === "YES" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredOneIndex)].toString().toUpperCase() === "Y" ) {
                                    planBenefitImport.coveredOne = true;
                                }
                                else {
                                    planBenefitImport.coveredOne = null;
                                }
                            }

                            if (planBenefitIndexCollection.tierNameTwoIndex > 0) {
                                planBenefitImport.tierNameTwo = rawCellArray[(rowMultiplier + planBenefitIndexCollection.tierNameTwoIndex)].toString();
                            }

                            if (planBenefitIndexCollection.tierBenefitTwoIndex > 0) {
                                planBenefitImport.tierBenefitTwo = rawCellArray[(rowMultiplier + planBenefitIndexCollection.tierBenefitTwoIndex)].toString();
                            }

                            if (planBenefitIndexCollection.coveredTwoIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredTwoIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredTwoIndex)].toString().toUpperCase() === "N" ) {
                                    planBenefitImport.coveredTwo = false;
                                }
                                else if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredTwoIndex)].toString().toUpperCase() === "YES" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredTwoIndex)].toString().toUpperCase() === "Y" ) {
                                    planBenefitImport.coveredTwo = true;
                                }
                                else {
                                    planBenefitImport.coveredTwo = null;
                                }
                            }

                            if (planBenefitIndexCollection.tierNameThreeIndex > 0) {
                                planBenefitImport.tierNameThree = rawCellArray[(rowMultiplier + planBenefitIndexCollection.tierNameThreeIndex)].toString();
                            }

                            if (planBenefitIndexCollection.tierBenefitThreeIndex > 0) {
                                planBenefitImport.tierBenefitThree = rawCellArray[(rowMultiplier + planBenefitIndexCollection.tierBenefitThreeIndex)].toString();
                            }

                            if (planBenefitIndexCollection.coveredThreeIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredThreeIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredThreeIndex)].toString().toUpperCase() === "N" ) {
                                    planBenefitImport.coveredThree = false;
                                }
                                else if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredThreeIndex)].toString().toUpperCase() === "YES" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.coveredThreeIndex)].toString().toUpperCase() === "Y" ) {
                                    planBenefitImport.coveredThree = true;
                                }
                                else {
                                    planBenefitImport.coveredThree = null;
                                }
                            }

                            if (planBenefitIndexCollection.planIDIndex > 0) {
                                planBenefitImport.plan_ID = rawCellArray[(rowMultiplier + planBenefitIndexCollection.planIDIndex)].toString();
                            }

                            if (planBenefitIndexCollection.tierOneIndex > 0) {
                                planBenefitImport.tierOne = parseNumber(rawCellArray[(rowMultiplier + planBenefitIndexCollection.tierOneIndex)]);
                            }

                            if (planBenefitIndexCollection.dedOneIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedOneIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedOneIndex)].toString().toUpperCase() === "N" ) {
                                    planBenefitImport.dedOne = false;
                                }
                                else if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedOneIndex)].toString().toUpperCase() === "YES" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedOneIndex)].toString().toUpperCase() === "Y" ) {
                                    planBenefitImport.dedOne = true;
                                }
                                else {
                                    planBenefitImport.dedOne = null;
                                }
                            }

                            if (planBenefitIndexCollection.copayOneIndex > 0) {
                                planBenefitImport.copayOne = parseNumber(rawCellArray[(rowMultiplier + planBenefitIndexCollection.copayOneIndex)]);
                            }

                            if (planBenefitIndexCollection.tierTwoIndex > 0) {
                                planBenefitImport.tierTwo = parseNumber(rawCellArray[(rowMultiplier + planBenefitIndexCollection.tierTwoIndex)]);
                            }

                            if (planBenefitIndexCollection.dedTwoIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedTwoIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedTwoIndex)].toString().toUpperCase() === "N" ) {
                                    planBenefitImport.dedTwo = false;
                                }
                                else if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedTwoIndex)].toString().toUpperCase() === "YES" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedTwoIndex)].toString().toUpperCase() === "Y" ) {
                                    planBenefitImport.dedTwo = true;
                                }
                                else {
                                    planBenefitImport.dedTwo = null;
                                }
                            }

                            if (planBenefitIndexCollection.copayTwoIndex > 0) {
                                planBenefitImport.copayTwo = parseNumber(rawCellArray[(rowMultiplier + planBenefitIndexCollection.copayTwoIndex)]);
                            }

                            if (planBenefitIndexCollection.tierThreeIndex > 0) {
                                planBenefitImport.tierThree = parseNumber(rawCellArray[(rowMultiplier + planBenefitIndexCollection.tierThreeIndex)]);
                            }

                            if (planBenefitIndexCollection.dedThreeIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedThreeIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedThreeIndex)].toString().toUpperCase() === "N" ) {
                                    planBenefitImport.dedThree = false;
                                }
                                else if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedThreeIndex)].toString().toUpperCase() === "YES" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedThreeIndex)].toString().toUpperCase() === "Y" ) {
                                    planBenefitImport.dedThree = true;
                                }
                                else {
                                    planBenefitImport.dedThree = null;
                                }
                            }

                            if (planBenefitIndexCollection.copayThreeIndex > 0) {
                                planBenefitImport.copayThree = parseNumber(rawCellArray[(rowMultiplier + planBenefitIndexCollection.copayThreeIndex)]);
                            }

                            if (planBenefitIndexCollection.inNetworkIndex > 0) {
                                planBenefitImport.inNetwork = parseNumber(rawCellArray[(rowMultiplier + planBenefitIndexCollection.inNetworkIndex)]);
                            }

                            if (planBenefitIndexCollection.dedFourIndex > 0) {
                                if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedFourIndex)].toString().toUpperCase() === "NO" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedFourIndex)].toString().toUpperCase() === "N" ) {
                                    planBenefitImport.dedFour = false;
                                }
                                else if (rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedFourIndex)].toString().toUpperCase() === "YES" ||
                                    rawCellArray[(rowMultiplier + planBenefitIndexCollection.dedFourIndex)].toString().toUpperCase() === "Y" ) {
                                    planBenefitImport.dedFour = true;
                                }
                                else {
                                    planBenefitImport.dedFour = null;
                                }
                            }

                            if (planBenefitIndexCollection.copayFourIndex > 0) {
                                planBenefitImport.copayFour = parseNumber(rawCellArray[(rowMultiplier + planBenefitIndexCollection.copayFourIndex)]);
                            }

                            if (planBenefitIndexCollection.outOfNetworkIndex > 0) {
                                planBenefitImport.outOfNetwork = parseNumber(rawCellArray[(rowMultiplier + planBenefitIndexCollection.outOfNetworkIndex)]);
                            }

                            if (planBenefitIndexCollection.copayFiveIndex > 0) {
                                planBenefitImport.copayFive = parseNumber(rawCellArray[(rowMultiplier + planBenefitIndexCollection.copayFiveIndex)]);
                            }

                            planBenefitImport.vbasoftware_database = currentDB;

                            planBenefitImport.vbapi_Token = getWithExpiry('vbapi_Token');

                            const baseValid = (hasValue(planBenefitImport.benefitCode) || hasValue(planBenefitImport.tierBenefit) || hasValue(planBenefitImport.tierBenefitTwo) || hasValue(planBenefitImport.tierBenefitThree)) && hasValue(planBenefitImport.plan_ID);

                            const bValid = !hasValue(planBenefitImport.benefitCode) || hasValue(planBenefitImport.covered);
                            const eValid = !hasValue(planBenefitImport.tierBenefit) || (hasValue(planBenefitImport.tierName) && hasValue(planBenefitImport.coveredOne));
                            const hValid = !hasValue(planBenefitImport.tierBenefitTwo) || (hasValue(planBenefitImport.tierNameTwo) && hasValue(planBenefitImport.coveredTwo));
                            const kValid = !hasValue(planBenefitImport.tierBenefitThree) || (hasValue(planBenefitImport.tierNameThree) && hasValue(planBenefitImport.coveredThree));

                            const isValid = baseValid && bValid && eValid && hValid && kValid;

                            if (isValid) {
                                planBenefitImportArray.push({...planBenefitImport});
                            }

                            planBenefitImport.description = initialPlanBenefitImport.description;
                            planBenefitImport.benefitCode = initialPlanBenefitImport.benefitCode;
                            planBenefitImport.covered = initialPlanBenefitImport.covered;
                            planBenefitImport.tierName = initialPlanBenefitImport.tierName;
                            planBenefitImport.tierBenefit = initialPlanBenefitImport.tierBenefit;
                            planBenefitImport.coveredOne = initialPlanBenefitImport.coveredOne;
                            planBenefitImport.tierNameTwo = initialPlanBenefitImport.tierNameTwo;
                            planBenefitImport.tierBenefitTwo = initialPlanBenefitImport.tierBenefitTwo;
                            planBenefitImport.coveredTwo = initialPlanBenefitImport.coveredTwo;
                            planBenefitImport.tierNameThree = initialPlanBenefitImport.tierNameThree;
                            planBenefitImport.tierBenefitThree = initialPlanBenefitImport.tierBenefitThree;
                            planBenefitImport.coveredThree = initialPlanBenefitImport.coveredThree;
                            planBenefitImport.plan_ID = initialPlanBenefitImport.plan_ID;
                            planBenefitImport.tierOne = initialPlanBenefitImport.tierOne;
                            planBenefitImport.dedOne = initialPlanBenefitImport.dedOne;
                            planBenefitImport.copayOne = initialPlanBenefitImport.copayOne;
                            planBenefitImport.tierTwo = initialPlanBenefitImport.tierTwo;
                            planBenefitImport.dedTwo = initialPlanBenefitImport.dedTwo;
                            planBenefitImport.copayTwo = initialPlanBenefitImport.copayTwo;
                            planBenefitImport.tierThree = initialPlanBenefitImport.tierThree;
                            planBenefitImport.dedThree = initialPlanBenefitImport.dedThree;
                            planBenefitImport.copayThree = initialPlanBenefitImport.copayThree;
                            planBenefitImport.inNetwork = initialPlanBenefitImport.inNetwork;
                            planBenefitImport.dedFour = initialPlanBenefitImport.dedFour;
                            planBenefitImport.copayFour = initialPlanBenefitImport.copayFour;
                            planBenefitImport.outOfNetwork = initialPlanBenefitImport.outOfNetwork;
                            planBenefitImport.copayFive = initialPlanBenefitImport.copayFive;

                            clearPlanBenefitImport();
                        }


                        //excelData.Sheets.PlanBenefit = undefined;
                    }
                    else {
                        //setValidationText("Group ID, Plan ID, and Vendor are required.");
                        //setValidationError(true);
                    }

                    //TODO: validate that at least one of these has been passed in
                    //importPlanBuildImports(planBuildImportArray, planTierImportArray, planBenefitImportArray);
                }
                const hasAnyRows =
                    planBuildImportArray.length > 0 ||
                    planTierImportArray.length > 0 ||
                    planBenefitImportArray.length > 0;

                if (hasAnyRows) {
                    await importPlanBuildImports(
                        planBuildImportArray,
                        planTierImportArray,
                        planBenefitImportArray
                    );
                } else {
                    setValidationText("No valid rows found.");
                    setValidationError(true);
                }
            }

            catch(e) {
                console.log("ERROR", e);

                setErrorAlert(true);
                //clear it out after errors in case of rerendering otherwise the error spams will continue until morale improves
                excelData.Sheets.PlanBenefit = undefined;
                excelData.Sheets.Tiers = undefined;
                excelData.Sheets.PlanBuild = undefined;
            } finally {
                isRunningRef.current = false;
            }
        };
        void runImport();

    }, [excelData, currentDB]);

    return (
        <div>
            {successAlert ? <Alert className="groupAlertStyles" severity='success' onClose={() => setSuccessAlert(false)} variant="filled">
                <AlertTitle>Success!</AlertTitle>
                Bulk Plan Import Complete!
            </Alert> : <></> }
            {errorAlert ? <Alert className="groupAlertStyles" severity='error' onClose={() => setErrorAlert(false)} variant="filled">
                <AlertTitle>Error!</AlertTitle>
                There was an error with this file!
            </Alert> : <></> }
            <Dialog
                open={validationError}
                onClose={handleValidationClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                    {"Validation Error"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {validationText}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleValidationClose}>OK</Button>
                </DialogActions>
            </Dialog>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={isLoading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
}
const hasValue = (value: unknown): boolean =>
    value !== null && value !== undefined && String(value).trim() !== "";

export default React.memo(BulkPlanBuildImporter)

BulkPlanBuildImporter.propTypes = {
    excelData: PropTypes.object.isRequired
};